import {
  GridFilterInputMultipleSingleSelect,
  type GridFilterOperator,
} from "@mui/x-data-grid-premium";

export const getDataGridMultiSelectFilterOperators =
  (): GridFilterOperator[] => [
    {
      value: "is",
      headerLabel: "Is",
      getApplyFilterFn: (filterItem) => {
        return (value) => {
          if (!filterItem.value) {
            return false;
          }
          return value === filterItem;
        };
      },

      label: "Is",
      InputComponent: GridFilterInputMultipleSingleSelect,
    },
  ];
